// extracted by mini-css-extract-plugin
export var bad = "what-module--bad--a3f58";
export var btn = "what-module--btn--60bf7";
export var col = "what-module--col--dd505";
export var row = "what-module--row--a3060";
export var what = "what-module--what--f22ee";